import React from 'react';
import {Button} from 'components';
import {Announcement} from './announcement';
import css from './announcement.module.scss';

export class Update_2024_12_22 extends Announcement {
  render() {
    return (
      <>
        <h1>A.I. Powered SMART Goal Setting</h1>
        <p>ChatGPT is now integrated into the Goal Setting process to help you define your Goals and create a detailed Action Plan to achieve them.</p>
        <p className={css.footer}>
          <Button onClick={this.props.decline}>
            {this.props.isLast ? 'close' : 'next'}
          </Button>
        </p>
      </>
    );
  }
}
